import Axios from 'axios';
import React from 'react';
import { Alert, CloseIcon, Dialog } from '@fluentui/react-northstar';
import { Trans, withTranslation, WithTranslation } from 'react-i18next';
import { GetProductsDTO } from '../../../../models/Administration/CANCOMProductController/getProductsDTO';
import { LocalizationService } from '../../../../services/LocalizationService';

interface ICANCOMProductDeleteDialogProps extends WithTranslation {
    onClose?: any;
    product: GetProductsDTO;
}

interface ICANCOMProductDeleteDialogState {
    error: string | null;
    loading: boolean;
}

class CANCOMProductDeleteDialog extends React.Component<ICANCOMProductDeleteDialogProps, ICANCOMProductDeleteDialogState> {

    public state: ICANCOMProductDeleteDialogState = {
        error: null,
        loading: false,
    }

    public async componentDidMount() {

    }

    public submitForm = async () => {
        try {
            this.setState({ loading: true, error: null });
            await Axios.delete(window.env.REACT_APP_API_BASE + '/api/admin/cancom/products/' + this.props.product?.id);
            this.setState({ loading: false });
            this.props.onClose(true);
        } catch (error: any) {
            console.error(error);
            if (error?.response?.data?.errorCode) {
                this.setState({ loading: false, error: error.response.data.errorCode });
            } else {
                this.setState({ loading: false, error: 'error.admin.cancom.products.deleteproduct' });
            }
        }
    }

    render() {

        const content = (
            <React.Fragment>
                {!this.state.loading && this.state.error ? <Alert danger={true} content={this.props.t(this.state.error)} /> : null}
                <div style={{ marginTop: '6px' }}><Trans i18nKey="admin.cancom.products.dialog.delete.message" values={{ title: LocalizationService.getLocalizedString(this.props.product.title, this.props.i18n.language) }} /></div>
            </React.Fragment>
        );

        return (
            <Dialog
                open={true}
                styles={{ width: '420px' }}
                closeOnOutsideClick={false}
                onCancel={() => this.props.onClose && this.props.onClose(false)}
                onConfirm={this.submitForm}
                cancelButton={{ content: this.props.t('admin.cancom.products.dialog.common.cancel'), disabled: this.state.loading }}
                confirmButton={{ content: this.props.t('admin.cancom.products.dialog.delete.confirm'), primary: true, disabled: this.state.loading, loading: this.state.loading }}
                content={content}
                header={this.props.t('admin.cancom.products.dialog.delete.title')}
                headerAction={{ icon: <CloseIcon />, title: this.props.t('admin.cancom.products.dialog.common.close'), onClick: () => this.props.onClose && this.props.onClose(false), disabled: this.state.loading }} />
        );

    }

}

export default withTranslation()(CANCOMProductDeleteDialog);